import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import { FormattedMessage } from "react-intl";

import { Button } from "@stubhub/bamboo";
import FormattedLink from "@stubhub/react-formatted-link";
import { theme } from "@stubhub/react-theme-provider";

import { domainUrl } from "./utils";

import "./index.scss";

const message = (
  <FormattedMessage
    id="SearchResults.RequestEvents.NoEventsFound.Description"
    defaultMessage={"We're happy to add your event to StubHub if it's not here"}
  />
);
const requestEventMessage = (
  <FormattedMessage
    id="SearchResults.RequestEvents.Message"
    defaultMessage="request an event!"
  />
);
const addEventMessage = (
  <FormattedMessage
    id="SearchResults.RequestEvents.AddEvent.Description"
    defaultMessage="we'll add it."
  />
);

// Cxs is mandatory here, cannot test branch coverage
/* istanbul ignore next */
const themeLinkColorClassName = (theme = {}, cxs) =>
  theme.keyTextLinks &&
  cxs &&
  cxs({
    color: `${theme.keyTextLinks} !important`,
    fontWeight: 500,
  });

const RequestEventsComponent = ({
  className = "",
  showImage = true,
  storeId = 2,
}) => {
  const requestFormUrl = domainUrl[storeId] || domainUrl[2];

  return !showImage ? (
    <div className={cs("RequestEvents__MessageVariant", className)}>
      <h4 className="RequestEvents__MessageVariantHeader">
        <FormattedMessage
          id="SearchResults.RequestEvents.Header"
          defaultMessage="Request an event"
        />
      </h4>
      <span className="RequestEvents__MessageVariantDescription">
        <FormattedMessage
          id="SearchResults.RequestEvents.SideBar.Description"
          defaultMessage="We are experts on covering live events. If we don't have yours, {link}."
          values={{
            link: (
              <FormattedLink
                target="_blank"
                href={requestFormUrl}
                className={`RequestEvents__requestEvent ${themeLinkColorClassName(
                  theme
                )}`}
              >
                {addEventMessage}
              </FormattedLink>
            ),
          }}
        />
      </span>
    </div>
  ) : (
    <div className={cs("RequestEvents__ImageVariant", className)}>
      <div className="RequestEvents__placeholderImage" />
      <div className="RequestEvents__placeholderText">
        {message}
        <Button
          className="RequestEvents__button"
          target="_blank"
          href={requestFormUrl}
          size="md"
        >
          {requestEventMessage}
        </Button>
      </div>
    </div>
  );
};

RequestEventsComponent.propTypes = {
  /**
   * Custom className
   */
  className: PropTypes.string,

  /**
   * Current store id
   */
  storeId: PropTypes.number,

  /**
   * Show event request with image?
   */
  showImage: PropTypes.bool,
};

export default RequestEventsComponent;
